export const WAIT_TIME_RESEND_CODE = 60;
